/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Delete_Preset_Button_Aria_LabelInputs */

const en_styles_delete_preset_button_aria_label = /** @type {(inputs: Styles_Delete_Preset_Button_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete Preset`)
};

const fr_styles_delete_preset_button_aria_label = /** @type {(inputs: Styles_Delete_Preset_Button_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer le preset`)
};

const de_styles_delete_preset_button_aria_label = /** @type {(inputs: Styles_Delete_Preset_Button_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voreinstellung löschen`)
};

const it_styles_delete_preset_button_aria_label = /** @type {(inputs: Styles_Delete_Preset_Button_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina preimpostazione`)
};

const ru_styles_delete_preset_button_aria_label = /** @type {(inputs: Styles_Delete_Preset_Button_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить предустановку`)
};

const es_styles_delete_preset_button_aria_label = /** @type {(inputs: Styles_Delete_Preset_Button_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar ajuste preestablecido`)
};

const zh_cn2_styles_delete_preset_button_aria_label = /** @type {(inputs: Styles_Delete_Preset_Button_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除预设`)
};

const ja_styles_delete_preset_button_aria_label = /** @type {(inputs: Styles_Delete_Preset_Button_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プリセットを削除`)
};

const hi_styles_delete_preset_button_aria_label = /** @type {(inputs: Styles_Delete_Preset_Button_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रीसेट हटाएं`)
};

const pt_pt2_styles_delete_preset_button_aria_label = /** @type {(inputs: Styles_Delete_Preset_Button_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir predefinição`)
};

/**
* | output |
* | --- |
* | "Delete Preset" |
*
* @param {Styles_Delete_Preset_Button_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_delete_preset_button_aria_label = /** @type {((inputs?: Styles_Delete_Preset_Button_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Delete_Preset_Button_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_styles_delete_preset_button_aria_label(inputs)
	if (locale === "de") return de_styles_delete_preset_button_aria_label(inputs)
	if (locale === "it") return it_styles_delete_preset_button_aria_label(inputs)
	if (locale === "ru") return ru_styles_delete_preset_button_aria_label(inputs)
	if (locale === "es") return es_styles_delete_preset_button_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_styles_delete_preset_button_aria_label(inputs)
	if (locale === "ja") return ja_styles_delete_preset_button_aria_label(inputs)
	if (locale === "hi") return hi_styles_delete_preset_button_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_styles_delete_preset_button_aria_label(inputs)
	return en_styles_delete_preset_button_aria_label(inputs)
});